import * as $ from 'jquery';
import 'bootstrap';
import 'slick';
import 'simplePagination';
import 'MagnificPopup';

export class experienceEntertainment{
	entertainmentSlider(): any{
		$('.entertainment').slick({
			infinite: false,
			speed: 300,
			slidesToShow: 4,
			slidesToScroll: 2,
			dots: false,
			disableOn: 0,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						dots: false
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: false
					}
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]
		});
	}

	entertainmentWatchVideo(): any{
		$('.watch-trailer').magnificPopup({
			disableOn: 0,
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false
		});
	}

	entertainmentPagination(): any{
		let $listItems: any = $('#list-container li');
		let $numItems: any = $listItems.length;
		//let $listItemPerPage: any = $('#list-container').attr('data-listitems');
		let $itemPerPage: any = 16;
		let $pagination = $('#pagination');

		$listItems.slice($itemPerPage).hide();

		$pagination.pagination({
				items: $numItems,
				itemsOnPage: $itemPerPage,
				cssStyle: "light-theme",
				onPageClick: function(pageNumber: any) {
					let $showFrom: any = $itemPerPage * (pageNumber - 1);
					let $showTo: any  = $showFrom + $itemPerPage;

					$listItems.hide()
						.slice($showFrom, $showTo).show();
				}
		});

		$('#pagination li a').on('click', () =>{
			$('html, body').animate({ scrollTop: 0 }, 'slow');
			return false;
		});
	}
}

let scope:Element = document.querySelector('.experience-entertainment');
if (scope){
	try {
	let experienceentertainment = new experienceEntertainment();
			experienceentertainment.entertainmentSlider();
			experienceentertainment.entertainmentPagination();
			experienceentertainment.entertainmentWatchVideo();
	} catch(e) {console.error(e);}
}
